$(document).on('click', '.js-my-account-remove-photo-btn', function () {
    $('.js-my-account-edit-photo-controls').removeClass('uploaded');
    $('.js-profile-photo').removeClass('uploaded').attr('src', '');
    $('.js-cropper-image').attr('src', '');
});
